import { Socket } from 'phoenix';
import PropTypes from 'prop-types';
import { createContext, useEffect, useState } from 'react';
import { configVars } from 'src/helpers';

interface PhoenixSocketContextType {
  socket: Socket | null;
}

const PhoenixSocketContext = createContext<PhoenixSocketContextType>({ socket: null });

const PhoenixSocketProvider = ({
  children,
  token
}: {
  children: React.ReactNode;
  token: string;
}) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (!token) return;

    const socket = new Socket(`${configVars.server_url}/socket`, { params: { token: token } });
    socket.connect();
    setSocket(socket);
  }, [token]);

  if (!socket) return null;

  return (
    <PhoenixSocketContext.Provider value={{ socket }}>{children}</PhoenixSocketContext.Provider>
  );
};

PhoenixSocketProvider.propTypes = {
  children: PropTypes.node
};

export { PhoenixSocketContext, PhoenixSocketProvider };
